// ** Next Imports
import Link from "next/link";

// ** File Imports
import Layout, { SEOHead } from "../../layouts/default";

import { SUPPORT_LINKS } from "../../helpers/DATA";
import { SiteMessagesType } from "../../db/schemas/siteMessages";
import { Alert } from "react-bootstrap";
import { alertColorToReactstrap } from "../../helpers";
import { getActiveSiteMessage } from "../../db/models/siteMessages";

const Support = ({ siteMessage }: { siteMessage: SiteMessagesType | null }) => {
  return (
    <Layout>
      <SEOHead title="Easy Internet Now| EIN Support | EIN Helpline">
        <meta
          name="description"
          content="If you face any problem after you get an internet connection from EIN, you can get reach out to their helpline. The provide amazing customer service support."
        ></meta>
        <meta
          name="keywords"
          content="Easy Internet Now support, EIN Support, EIN Helpline"
        />
      </SEOHead>

      <section className="bg-silver1 pad-top-40 pad-bot-40">
        <div className="container">
          <div className="sec-head">
            <h1 className="no-margin">
              <b>Support</b>
            </h1>
          </div>
        </div>
      </section>

      <section className="pad-top-80 pad-bot-60 animate__animated animate__backInUp">
        <div className="container">
          {siteMessage != null && siteMessage.active && (
            <div className="block-element m-b-20">
              <div className="textual-sec1">
                <Alert
                  variant={alertColorToReactstrap(siteMessage.alertType)}
                  style={{ whiteSpace: "pre-wrap" }}
                >
                  {siteMessage.message}
                </Alert>
              </div>
            </div>
          )}

          <div className="block-element m-b-50">
            <div className="textual-sec2">
              <h3 className="col-black">
                Get answers to the most common questions.
              </h3>
              <p className="col-grey1">
                EIN provides superior support for all customers. If you have
                questions about your account or your Internet connection,
                we&apos;re here for you! Our robust Knowledge Base offers help
                without needing to make a call.
              </p>
            </div>
          </div>

          <div className="block-element">
            <div className="row">
              {Object.keys(SUPPORT_LINKS).map((catName, index) => {
                const lnks = SUPPORT_LINKS[catName];

                return (
                  <div
                    className="col-md-3 col-lg-3 col-sm-6 col-12"
                    key={`sct-${index}`}
                  >
                    <div className="support-box custom-border1">
                      <h3 className="col-black"> Internet Connection </h3>
                      <ul className="list-1">
                        {Object.keys(lnks).map((lnk, lkI) => (
                          <li key={`cl-${lkI}`}>
                            <Link href={lnks[lnk]}>{lnk}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export async function getServerSideProps() {
  // Get site message
  const siteMessage = await getActiveSiteMessage("Support");

  //Return data
  return {
    props: {
      siteMessage: JSON.parse(JSON.stringify(siteMessage)),
    },
  };
}

export default Support;
